import { render, staticRenderFns } from "./coperarkmanrestaurantrezaktarim.vue?vue&type=template&id=516805c9&"
import script from "./coperarkmanrestaurantrezaktarim.vue?vue&type=script&lang=js&"
export * from "./coperarkmanrestaurantrezaktarim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports